import React, { useState, useEffect } from 'react';

import Typography from '@/components/Typography';

import { fetchUsers } from '@/services/api/users';
import { Input } from '@/components/ui/input';

import { DatePickerWithRange } from '@/components/DatePickerWithRange/DatePickerWithRange';
import { Banknote, Shield, User } from 'lucide-react';
import { Role } from '@/domains/user';
import { Card, CardContent } from '@/components/ui/card';
import UserListTable from '@/components/UserListTable/UserListTable';

interface Filter {
  term: string;
  date?: {
    from: Date;
    to: Date;
  };
}

const UsersListPage: React.FC = () => {
  const [filter, setFilter] = useState<Filter>({ term: '', date: null });
  const [debouncedTerm, setDebouncedTerm] = useState('');

  // Debounce the search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(filter.term);
    }, 300); // 300ms delay

    return () => clearTimeout(timer);
  }, [filter.term]);

  return (
    <div className="space-y-4">
      <div className="flex flex-col">
        <Typography is="h1" size="2xl" weight="bold">
          Users
        </Typography>
      </div>

      <div className="flex flex-row space-x-4">
        <Input placeholder="Filter by name or email" onChange={(e) => setFilter({ ...filter, term: e.target.value })} />

        <DatePickerWithRange placeholder="Joined between" onChange={(e) => setFilter({ ...filter, date: e })} />
      </div>

      <Card>
        <CardContent>
          <UserListTable
            key={`${debouncedTerm}-${filter.date?.from?.toISOString()}-${filter.date?.to?.toISOString()}`}
            source={(page, count) =>
              fetchUsers(page, count, {
                organisationId: null,
                vendorId: null,
                term: debouncedTerm,
                joinedAfter: filter.date?.from,
                joinedBefore: filter.date?.to
              })
            }
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default UsersListPage;
